<myre-calendar
  [numberOfMonthsDisplayed]="numberOfMonths"
  [startDate]="startAt"
  [selectedDates]="value"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [dateFilter]="dateFilter"
  [multiSelect]="multiSelect"
  (selectDates)="onChange($event)"
/>
